import { RootState } from "./store";

// =====================================================
// Acesso centralizado ao organizationId do usuario logado.
//
// Antes, ~25 lugares faziam state.user.userInfo.organizationUsers[0]
// .organization.id direto — quebrando com "Cannot read properties of
// undefined" para usuarios sem organizacao (cliente recem-registrado,
// depositor). Use estes helpers em vez do acesso cru.
// =====================================================

/** Org id do usuario logado, ou undefined se nao houver organizacao. */
export const tryGetOrgId = (state: RootState): number | undefined =>
    state.user?.userInfo?.organizationUsers?.[0]?.organization?.id;

/**
 * Org id do usuario logado. Lanca um erro claro se nao houver organizacao.
 * Use em fluxos que so rodam em telas de empresa (protegidas por rota) — assim
 * um acesso indevido falha com mensagem explicita em vez de um TypeError obscuro.
 */
export const getOrgId = (state: RootState): number => {
    const id = tryGetOrgId(state);
    if (!id) throw new Error('Usuario nao esta vinculado a nenhuma organizacao.');
    return id;
};
